export default __webpack_public_path__ + "static/media/Yantramanav-Thin.d9aa0f1b.ttf";